module.exports = __webpack_public_path__ + "img/paraproduksjoner.3bd54ae0.jpg";